import Swiper from "swiper";
import { Navigation, Pagination, Autoplay, A11y } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

function initSwipers() {
  const containers = document.querySelectorAll(".slider-staggered");
  containers.forEach((el) => {
    if (el.__swiper_inited) return;
    el.__swiper_inited = true;

    const pagination = el.querySelector(".swiper-pagination");
    const nextEl = el.querySelector(".swiper-button-next");
    const prevEl = el.querySelector(".swiper-button-prev");

    const swiper = new Swiper(el, {
      modules: [Pagination, Autoplay],
      spaceBetween: 64,
      speed: 500,
      loop: true,
      autoplay: {
        delay: 12000,
        disableOnInteraction: true,
      },
      pagination: pagination ? { el: pagination, clickable: true } : undefined,

      breakpoints: {
        0: {
          slidesPerView: 1.1,
          spaceBetween: 20,
        },
        450: {
          slidesPerView: 1.3,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 1,
          spaceBetween: 80,
        },
      },
    });

    // Expose for debugging
    el.__swiper = swiper;
  });
}

function initTeamSlider() {
  const wrappers = document.querySelectorAll("[data-slider-team]");
  wrappers.forEach((wrapper) => {
    const slider = wrapper.querySelector(".slider-team");
    if (!slider || slider.__swiper_inited) return;
    slider.__swiper_inited = true;

    const nextEl = wrapper.querySelector("[data-slider-team-next]");
    const prevEl = wrapper.querySelector("[data-slider-team-prev]");

    const swiper = new Swiper(slider, {
      modules: [Navigation, Pagination, Autoplay],
      speed: 500,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      spaceBetween: 32,
      ...(nextEl && prevEl ? { navigation: { nextEl, prevEl } } : {}),
      initialSlide: 2,
      breakpoints: {
        0: {
          slidesPerView: 1.6,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 28,
        },
        1440: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
      },
    });

    slider.__swiper = swiper;
  });
}

function initSfeerbeeldenSlider() {
  const wrappers = document.querySelectorAll("[data-slider-sfeerbeelden]");
  wrappers.forEach((wrapper) => {
    const slider = wrapper.querySelector(".slider-sfeerbeelden");
    if (!slider || slider.__swiper_inited) return;
    slider.__swiper_inited = true;

    const nextEl = wrapper.querySelector("[data-sfeerbeelden-next]");
    const prevEl = wrapper.querySelector("[data-sfeerbeelden-prev]");

    const swiper = new Swiper(slider, {
      modules: [Navigation, Autoplay],
      speed: 600,
      loop: true,
      loopAdditionalSlides: 3,
      autoplay: {
        delay: 3500,
        disableOnInteraction: true,
      },
      spaceBetween: 8,
      ...(nextEl && prevEl ? { navigation: { nextEl, prevEl } } : {}),
      breakpoints: {
        0: {
          slidesPerView: 1.6,
          spaceBetween: 8,
          centeredSlides: true,
        },
        640: {
          slidesPerView: 2.5,
          spaceBetween: 8,
          centeredSlides: false,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 8,
          centeredSlides: false,
        },
        1440: {
          slidesPerView: 5,
          spaceBetween: 8,
          centeredSlides: false,
        },
      },
    });

    slider.__swiper = swiper;
  });
}

function initProductSlider() {
  const root = document.querySelector(".slider-products");
  if (!root) return;
  const el = root;
  if (!el || el.__swiper_inited) return;
  el.__swiper_inited = true;

  // Arrows live next to the slider (in its wrapper) so they sit in the side gutters, not over the cards.
  const scope = root.parentElement ?? root;
  const nextEl = scope.querySelector(".swiper-button-next");
  const prevEl = scope.querySelector(".swiper-button-prev");

  const swiper = new Swiper(el, {
    modules: [Navigation, Pagination, A11y],
    slidesPerView: 4,
    spaceBetween: 30,
    speed: 500,
    loop: false,
    ...(nextEl && prevEl ? { navigation: { nextEl, prevEl } } : {}),
    // Arrows are divs: A11y makes them focusable buttons; keep the translated labels from the template.
    a11y: {
      nextSlideMessage: nextEl?.getAttribute("aria-label") ?? "",
      prevSlideMessage: prevEl?.getAttribute("aria-label") ?? "",
      slideLabelMessage: "{{index}} / {{slidesLength}}",
    },
    breakpoints: {
      0: {
        slidesPerView: 1.1,
        spaceBetween: 16,
      },
      350: {
        slidesPerView: 2,
        spaceBetween: 16,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 28,
      },
      1440: {
        slidesPerView: 4,
        spaceBetween: 40,
      },
    },
  });
  el.__swiper = swiper;
}

function initCompareSlider() {
  const root = document.querySelector(".compare-swiper");
  if (!root || root.__swiper_inited) return;
  root.__swiper_inited = true;

  const wrapper = root.closest("[data-compare-root]") || document;
  const nextEl = wrapper.querySelector("[data-compare-next]");
  const prevEl = wrapper.querySelector("[data-compare-prev]");

  const swiper = new Swiper(root, {
    modules: [Navigation],
    slidesPerView: 3,
    spaceBetween: 32,
    speed: 500,
    loop: false,
    ...(nextEl && prevEl ? { navigation: { nextEl, prevEl } } : {}),
    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 16,
      },
      768: {
        slidesPerView: 1.6,
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: 2.2,
        spaceBetween: 28,
      },
      1440: {
        slidesPerView: 3,
        spaceBetween: 32,
      },
    },
  });

  root.__swiper = swiper;
}

function initBlogSlider() {
  const root = document.querySelector(".slider-blogs");
  if (!root) return;
  const el = root;
  if (!el || el.__swiper_inited) return;
  el.__swiper_inited = true;

  const pagination = root.querySelector(".swiper-pagination");

  const swiper = new Swiper(el, {
    modules: [Pagination],
    speed: 500,
    loop: false,
    pagination: pagination ? { el: pagination, clickable: true } : undefined,

    breakpoints: {
      0: {
        slidesPerView: 1,
        spaceBetween: 40,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 120,
      },
    },
  });

  el.__swiper = swiper;

  function equalizeHeights() {
    const wrapper = root.querySelector(".swiper-wrapper");
    const slides = root.querySelectorAll(".swiper-slide");

    if (!(wrapper instanceof Element)) {
      console.warn("Wrapper not found or not an element:", wrapper);
      return;
    }

    const wrapperHeight = wrapper.offsetHeight;

    slides.forEach((slide) => {
      if (slide instanceof Element) {
        slide.style.height = `${wrapperHeight}px`;
      }
    });

    // console.log("✅ Slide heights set to wrapper height:", wrapperHeight);
  }

  setTimeout(() => {
    equalizeHeights();
  }, 0);

  window.addEventListener("resize", equalizeHeights);
}

var merken = new Swiper(".merken-swiper", {
  modules: [Autoplay],
  spaceBetween: 40,
  speed: 9000,
  slidesPerView: "auto",
  loop: true,
  centeredSlides: true,
  allowTouchMove: false,
  autoplay: {
    delay: 0.5,
    disableOnInteraction: true,
  },
  breakpoints: {
    0: {
      slidesPerView: 2,
      spaceBetween: 30,
    },
    480: {
      slidesPerView: 3,
      spaceBetween: 30,
    },
    767: {
      slidesPerView: 4,
      spaceBetween: 40,
    },
    992: {
      slidesPerView: 6,
      spaceBetween: 40,
    },
  },
});

function initVideoSlider() {
  document.querySelectorAll("[data-slider-videos]").forEach((wrapper) => {
    const slider = wrapper.querySelector(".slider-videos");
    if (!slider || slider.__swiper_inited) return;
    slider.__swiper_inited = true;

    const fraction = wrapper.querySelector("[data-slider-videos-fraction]");
    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    new Swiper(slider, {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 24,
      speed: reduceMotion ? 0 : 400,
      // One instance per breakpoint is display:none; re-measure when it becomes visible.
      observer: true,
      observeParents: true,
      navigation: {
        nextEl: wrapper.querySelector("[data-slider-videos-next]"),
        prevEl: wrapper.querySelector("[data-slider-videos-prev]"),
      },
      pagination: fraction ? { el: fraction, type: "fraction" } : undefined,
      on: {
        slideChange: (swiper) => swiper.slides.forEach((slide) => slide.querySelector("video")?.pause()),
      },
    });
  });
}

document.addEventListener("DOMContentLoaded", () => {
  initSwipers();
  initBlogSlider();
  initTeamSlider();
  initSfeerbeeldenSlider();
  initProductSlider();
  initCompareSlider();
  initVideoSlider();
});
